
import { useAppSelector } from '../..'
import { type IUserListResponse } from '../../../models/User'

export const getLoading = (): boolean => useAppSelector((state) => state.facultyAndStaff.loading)
export const actionLoading = (): boolean => useAppSelector((state) => state.facultyAndStaff.actionLoading)
export const getUserList = (): IUserListResponse => useAppSelector((state) => state.facultyAndStaff.userList)
